export const QB_MAPPING_TYPES = {
  Backcharge: {
    value: "Backcharge",
    label: "Backcharge",
  },
  InvoiceBillingCommitmentCustomField: {
    value: "InvoiceBillingCommitmentCustomField",
    label: "Invoice Billing Commitment Custom Field",
  },
};

export const QB_MAPPING_STRINGS = {
  creditMemoTitle: "Credit Memo Templates",
  creditMemoDescription:
    "Create and manage credit memo templates for QuickBooks integration.",
  creditMemoExistingTitle: "Existing Templates:",

  customFieldsTitle: "Custom Fields",
  customFieldsDescription: "Map MiBuild to QuickBooks Custom Fields.",
  customFieldsExistingTitle: "Existing Mappings:",

  labels: {
    mappingType: "Mapping Type",
    quickBooksItem: "QuickBooks Item",
    quickBooksCustomField: "QuickBooks Custom Field",
    miBuild: "MiBuild:",
    quickBooks: "QuickBooks:",
  },

  modal: {
    description:
      "Create and manage mappings for MiBuild to QuickBooks Items or Custom Fields.",
    createActionBackcharge: "Create Template",
    createActionCustomField: "Create Mapping",
    saveChanges: "Save Changes",
    cancel: "Cancel",
  },
};
